import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { I18nGuideModalComponent } from './i18n-guide-modal.component';

@Component({
  styleUrls: ['./common.scss'],
  template: `
    <div class="container">
      <glxy-alert class="i18n-alert" type="info" [showAction]="true" actionTitle="i18n update guide" (actionClick)="openI18nGuide()">
        Changing the name, description, or category? Keep <code>notification-type-definitions.ts</code>
        and <code>en_devel.json</code> in <code>libs/atlas</code> in sync or the settings UI will show raw keys.
      </glxy-alert>

      <notification-manage
        [typeId]="typeId$ | async"
        createRoute="/notifications/create"
        editRoute="/notifications/edit/"
        listRoute="/notifications"
        releaseRoute="/notifications/release/"
      />
    </div>
  `,
  standalone: false,
})
export class EditComponent {
  private route = inject(ActivatedRoute);
  private dialog = inject(MatDialog);

  public readonly typeId$: Observable<string> = this.route.params.pipe(map((r) => r.typeId));

  openI18nGuide(): void {
    this.dialog.open(I18nGuideModalComponent, { width: '680px' });
  }
}
